import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Navbar as BSNavbar, Nav, Container, Badge, Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import logoImg from '../assets/ecoempower-logo.png'
import { useAuth } from '../context/AuthContext'
import LanguageToggle from './LanguageToggle'

function Navbar() {
  const location = useLocation()
  const { user, logout, isCountryManager } = useAuth()
  const { t } = useTranslation()

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/'
    }
    return location.pathname.startsWith(path)
  }

  const linkStyle = (path) => ({
    color: isActive(path) ? 'white' : 'rgba(255,255,255,0.85)',
    fontWeight: isActive(path) ? 600 : 500,
    textDecoration: isActive(path) ? 'underline' : 'none',
    textDecorationColor: 'var(--color-primary-light)',
    textUnderlineOffset: '4px',
  })

  return (
    <BSNavbar expand="lg" className="navbar-theme mb-0" style={{ backgroundColor: 'var(--color-primary-dark)', borderBottom: '3px solid var(--color-primary-light)' }}>
      <Container fluid>
        <BSNavbar.Brand as={Link} to="/" className="d-flex align-items-center gap-2" style={{ color: 'white', fontWeight: 600, fontSize: '1.1rem', textDecoration: 'none' }}>
          <img src={logoImg} alt="ECOEMPOWER" style={{ height: '32px', width: 'auto' }} />
          <span>ICT Platform</span>
        </BSNavbar.Brand>
        <BSNavbar.Toggle aria-controls="basic-navbar-nav" style={{ borderColor: 'rgba(255,255,255,0.3)' }} />
        <BSNavbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-center">
            <Nav.Link as={Link} to="/" style={linkStyle('/')}>
              {t('nav.dashboard')}
            </Nav.Link>
            <Nav.Link as={Link} to="/communities" style={linkStyle('/communities')}>
              {t('nav.communities')}
            </Nav.Link>
            <Nav.Link as={Link} to="/planning" style={linkStyle('/planning')}>
              {t('nav.long_term_planning')}
            </Nav.Link>
            <Nav.Link as={Link} to="/documentation" style={linkStyle('/documentation')}>
              {t('nav.documentation')}
            </Nav.Link>
            {user && (
              <div className="d-flex align-items-center ms-3 ps-3" style={{ borderLeft: '1px solid rgba(255,255,255,0.25)' }}>
                <span style={{ color: 'rgba(255,255,255,0.9)', fontSize: '0.85rem', fontWeight: 500 }}>
                  {user.display_name || user.username}
                </span>
                {isCountryManager && user.country_name && (
                  <Badge bg="light" text="dark" className="ms-2" style={{ fontSize: '0.7rem', fontWeight: 500 }}>
                    {user.country_name}
                  </Badge>
                )}
                <LanguageToggle />
                <Button
                  variant="link"
                  size="sm"
                  onClick={logout}
                  style={{ color: 'rgba(255,255,255,0.75)', fontSize: '0.8rem', textDecoration: 'none', padding: '0 0 0 12px' }}
                  onMouseOver={(e) => e.currentTarget.style.color = 'white'}
                  onMouseOut={(e) => e.currentTarget.style.color = 'rgba(255,255,255,0.75)'}
                >
                  {t('nav.logout')}
                </Button>
              </div>
            )}
          </Nav>
        </BSNavbar.Collapse>
      </Container>
    </BSNavbar>
  )
}

export default Navbar
